<template>
  <div class="tag-filter">
    <multiselect
      v-model="value"
      :placeholder="$tc('user.filter.consumer')"
      label="full_name" track-by="full_name"
      :options="optionsEditorConsumers"
      :searchable="false"
      @input="inputHandler"
      multiple
    >
      <template slot="option" slot-scope="props">
        <div class="option__desc">
          <span class="option__title">{{ props.option.full_name }}</span>
        </div>
      </template>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import debounce from 'lodash.debounce'
export default {
  components: {
    Multiselect
  },
  data: () => ({
    value: []
  }),
  methods: {
    inputHandler: debounce(function () {
      const filterOptions = this.value.map(option => option.name)
      this.$emit('change', filterOptions)
    }, 350)
  },
  computed: {
    optionsEditorConsumers () {
      if (this.$store.state.editorConsumers) {
        return this.$store.state.editorConsumers
      }
      return []
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

